export enum TypeCalendrier {
	Accueil = 0,
	GestionDesAbsences = 1,
	EspaceSalarie = 2,
	EspaceValideurSalarie = 3,
	EspaceValideurExterne = 4
}



// WEBPACK FOOTER //
// ./src/shared/models/typeCalendrier.ts